// 公共仓库
import { 
  addPlayCount as addPlayCountApi,
  addUpvoteCount as addUpvoteCountApi,
  cutUpvoteCount as cutUpvoteCountApi,
  setIsPublic as setIsPublicApi,
  setIsNotPublic as setIsNotPublicApi,
  delClips as delClipsApi
} from '~/apis/app'
import type { RequestConfig } from '~/types/http'

export const useCommonStore = defineStore('commonStore', () => {
  /**
   * 增加音乐播放量
   */
  const addPlayCount = async (params: { uuid: string }, config?: Partial<RequestConfig>) => {
    return await addPlayCountApi(params, config)
  }

  /**
   * 喜欢音乐
   */
  const addUpvoteCount = async (params: { uuid: string }, config?: Partial<RequestConfig>) => {
    return await addUpvoteCountApi(params, config)
  }

  /**
   * 取消喜欢音乐
   */
  const cutUpvoteCount = async (params: { uuid: string }, config?: Partial<RequestConfig>) => {
    return await cutUpvoteCountApi(params, config)
  }

  /**
   * 公开音乐
   */
  const setIsPublic = async (params: { uuid: string }, config?: Partial<RequestConfig>) => {
    return await setIsPublicApi(params, config)
  }

  /**
   * 取消公开音乐
   */
  const setIsNotPublic = async (params: { uuid: string }, config?: Partial<RequestConfig>) => {
    return await setIsNotPublicApi(params, config)
  }

  /**
   * 删除/恢复接口
   * @param params - 请求参数对象
   * @param params.isDelete - 操作类型：'1'表示删除，'0'表示恢复
   * @param params.uuids - 要操作的UUID，多个UUID用逗号分隔
   * @param config - 可选的请求配置，用于覆盖默认配置
   */
  const delClips = async (params: { isDelete: string, uuids: string }, config?: Partial<RequestConfig>) => {
    return await delClipsApi(params, config)
  }

  return {
    addPlayCount,
    addUpvoteCount,
    cutUpvoteCount,
    setIsPublic,
    setIsNotPublic,
    delClips
  }
})
